import React from 'react';
import AlarmClock from '~/Components/Global/Assets/Svgs/AlarmClock';

const AlarmOptions = ({
  getCurrentAlarms,
  getSortedAlarms,
  handleShowAddAlarmModal,
  handleDeleteAlarm,
  formatAlarmDateTime,
}) => {
  const currentAlarms = getCurrentAlarms();
  const sortedAlarms = getSortedAlarms(currentAlarms);

  if (sortedAlarms.length === 0) {
    return (
      <div
        className="option-row"
        role="button"
        tabIndex="0"
        onClick={handleShowAddAlarmModal}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') e.target.click();
        }}
        aria-label="Set alarm"
      >
        <AlarmClock className="add-alarm-icon" />
        <span className="option-label">Add alarm</span>
        <span className="material-icons-outlined add-alarm-chevron">chevron_right</span>
      </div>
    );
  }

  return (
    <>
      {sortedAlarms.map((alarm, index) => (
        <div key={alarm.target_datetime} className="option-row alarm-display-row">
          <AlarmClock className="alarm-display-icon" />
          <span className="option-label alarm-datetime">
            {formatAlarmDateTime(alarm.target_datetime)}
          </span>
          <button
            className="alarm-delete-button"
            onClick={e => handleDeleteAlarm(e, alarm)}
            aria-label="Delete alarm"
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
      ))}
      <div
        className="option-row add-another-alarm-row"
        role="button"
        tabIndex="0"
        onClick={handleShowAddAlarmModal}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') e.target.click();
        }}
        aria-label="Add another alarm"
      >
        <span className="option-label">Add another alarm</span>
        <span className="material-icons-outlined add-alarm-chevron">chevron_right</span>
      </div>
    </>
  );
};

export default AlarmOptions;
